<template>
  <div ref="animation">
    <lottie :options="options" />
  </div>
</template>

<script>
import Lottie from "vue-lottie";
import * as animationData from "@/assets/animations/loading.json";

export default {
  components: {
    Lottie,
  },
  data() {
    return {
      options: {
        animationData: animationData.default,
        loop: true,
        autoplay: true,
      },
    };
  },
};
</script>
